<ion-footer [translucent]="true">
  <ion-toolbar>
    <ion-title>&nbsp;</ion-title>
  </ion-toolbar>
</ion-footer>
